<template>
  <b-modal id="ModalUsuarioPro" no-close-on-backdrop no-close-on-esc>
    <Header mini titulo="Token de acesso" icone="key" cor="verde" slot="modal-header" />
    <LoadingPadraoContainer
      v-if="loadingAcesso"
      class="loading-padrao-backdrop"
      background
      :fraseLoading="['Checando chave de acesso', 'Aguarde um momento']"
      delay="5000"
      classe="azul"
    />
    <div class="modal-token-corpo">
      <input
        v-for="(item, index) in inputs"
        :key="index"
        :ref="`inputKey${index}`"
        class="modal-token-input"
        v-model="item.key"
        type="text"
        v-mask="'#'"
      />
    </div>
    <div v-if="tokenInvalido" class="modal-token-invalido">
      Token inválido! Verifique o token informado.
    </div>
    <template slot="modal-footer">
      <BotaoPadrao
        ref="botaoAcessoPro"
        arredondadoEsquerda
        class="botao-modal"
        nome="Limpar"
        icone="edit"
        :click="limparKeys"
        cor="cinza"
        :desabilita="tokenAcesso.length == 0"
      />
      <BotaoPadrao
        ref="botaoAcessoPro"
        arredondadoEsquerda
        class="botao-modal"
        nome="Validar"
        icone="check"
        :click="handleClick"
        cor="verde"
        :desabilita="tokenAcesso.length < 4"
      />
    </template>
  </b-modal>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";
import TheMask from "vue-the-mask";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

import Api from "@/services/api.js";
import { mapActions } from "vuex";

export default {
  name: "ModalUsuarioPro",
  components: {
    BotaoPadrao,
    Header,
    TheMask,
    LoadingPadraoContainer
  },
  data() {
    return {
      inputs: [{ key: "" }, { key: "" }, { key: "" }, { key: "" }],
      tokenInvalido: false,
      loadingAcesso: false
    };
  },
  created() {
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },
  watch: {
    inputs: {
      deep: true,
      handler() {
        this.tokenInvalido = false;
        let index = this.inputs.findIndex(f => f.key === "");
        if (index == -1) {
          this.$refs.botaoAcessoPro.$children[0].$el.focus();
        } else {
          this.$refs[`inputKey${index}`][0].focus();
        }
      }
    }
  },
  computed: {
    tokenAcesso() {
      let key = "";
      this.inputs.forEach(e => {
        key += e.key;
      });
      return key;
    }
  },
  methods: {
    ...mapActions("auth", ["setToken"]),

    handleKey(event) {
      let modal = document.getElementById("ModalUsuarioPro");
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          this.handleClick();
        }
      }
    },
    async handleClick() {
      const postToken = {
        token: this.tokenAcesso
      };
      // console.log(postToken);
      try {
        this.loadingAcesso = true;
        let response = await new Api().post("Login/ValidarToken", postToken);
        this.setToken(response.dados.token);
        localStorage.setItem("token", response.dados.token);
        this.$root.$emit("bv::hide::modal", "ModalUsuarioPro");
      } catch (error) {
        this.tokenInvalido = true;
      }
      this.loadingAcesso = false;
    },
    limparKeys() {
      this.inputs.forEach(e => {
        e.key = "";
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-token-corpo {
  display: flex;
  justify-content: center;
}
.modal-token-input {
  border: 1px solid var(--cinza-borda);
  font-size: 35px;
  width: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  border-radius: 10px;
  text-align: center;
  margin: 0 10px;
  transition: border 0.5s ease-in-out;
  &:focus {
    border: 1px solid var(--azul2);
  }
}
.modal-token-invalido {
  margin-top: 14px;
  text-align: center;
  padding: 10px;
  border: 1px solid var(--vermelho4);
  background: var(--vermelho0);
  color: var(--vermelho5);
  border-radius: 10px;
}
</style>
